<!-- 
FORMULARIO COM DADOS ADICIONAIS DO PEDIDO DE VENDA
-->

<script>
import { SysVars } from '../main';
import { formatValue } from '../shared/utils'

export default {
    props: {
        pedv: {type: Object}, 
    },

    data () {
        return {

        }
    },

    computed: {
        statusPedido: function () {
            return this.$store.getters.getPdstatusList.length > 0
        },
    },

    filters: {
    },

    methods: {
        closeForm () {
            this.$emit('closeform')
        },

        handleSave () {
            this.$emit('save')
        },

    },

    watch: {

    },

    components: {

    },

    created () {
        //carrega lista de cadastro de status para selecao 
        this.$store.dispatch('loadPdstatus', {})
    },

    mounted () {
        this.$nextTick(function () {
            this.$refs.status.focus()
            jQuery('[data-toggle="tooltip"]').tooltip()
        })
    }

}

</script>

<template>
    <div class="status-popover" style="position: absolute; width: 350px; top: 15px; left: 65px; padding: 15px;">
        <div class="row mb-2">
            <div class="col-12">
                Selecione o status
            </div>
        </div>
        <div class="row">
            <form-field ref="status" v-model="pedv.codstatus" type="select2" col="12" :select2="{entity: 'pdstatus', minlength: 0}"></form-field>
        </div>
        <div class="row">
            <div class="col-12 mt-3 d-flex">
                <v-button label="Cancelar" @click="closeForm"></v-button>
                <v-button label="Salvar" :success="true" @click="handleSave"></v-button>
            </div>
        </div>
    </div>

</template>


<style>


.status-popover {
    z-index: 1051;
    margin-top: 3px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    position: absolute;
    padding: 10px;
    min-width: 200px;
    list-style: none;
    background-color: #fff;
    border: 1px solid #00000033;
    box-shadow: 0 5px 10px #00000033;
    background-clip: padding-box;
}    

</style>



// WEBPACK FOOTER //
// src/forms/pedido-status.vue